<!-- 生产周期 -->
<template>
  <div class="deltime">
    <div class="deltime__header">
      <p class="deltime__header__title">生产周期</p>
      <BaseLink href="https://www.hqpcb.com/youpin" target="_blank">
        出货标准
      </BaseLink>
    </div>
    <RadioTable2
      v-model="val"
      radioKey="name"
      radioLabel="#"
      :columns="columns"
      :tableData="options"
      @change="handleChange"
    >
      <template v-slot:colorHeader>
        <span class="deltime__colorHeader">
          <span>油墨</span>
          <!-- 油墨 冷偏工艺提示 -->
          <BaseTipPopover v-if="colorTips" :content="colorTips" />
        </span>
      </template>
      <template v-slot:color="{ row }">
        <span class="deltime__color">
          <ColorBlock :color="row.color" showLabel />
        </span>
      </template>
      <template slot="empty">
        暂无交期
      </template>
    </RadioTable2>
  </div>
</template>

<script>
import RadioTable2 from '@@/components/radioTable/index2'
import ColorBlock from '@@/components/colorBlock/index'

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => ([])
    },
    unsought: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    RadioTable2,
    ColorBlock
  },
  data() {
    return {
      val: this.value,
      columns: [
        { label: '交期', prop: 'name', minWidth: 100, formatter: row => row.standard_deltime || row.name  },
        { label: '油墨', prop: 'color', slot: 'color', headerSlot: 'colorHeader' },
        { label: '板厚', prop: 'bheight', width: 60 },
        { label: '加急费', prop: 'fee', formatter: row => row.fee > 0 ? `￥${row.fee}` : '无' },
      ],
    }
  },
  computed: {
    // 生产周期 油墨提示
    colorTips() {
      const { options, unsought, value } = this
      const firstItem = options[0] || {}
      const currentDelTime = options.find(i => i.name === value) || firstItem
      // 推荐选项
      const recommendItem = options.find(i => i.type == 2)
      let tips = currentDelTime.type == 1 && recommendItem ? `当前为冷偏工艺，交期需顺延${firstItem.name}，建议选择${recommendItem.color}` : ''
      // 冷偏工艺提示
      tips = {
        1: '当前为极冷偏工艺，将加收极冷偏工艺费，建议调整油墨颜色和板厚等参数',
        2: `当前为冷偏工艺，交期需顺延${firstItem ? firstItem.name : ''}，建议调整油墨颜色和板厚等参数`
      }[unsought] || tips
      return tips
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      // this.$emit('input', this.val)
      this.$emit('change', this.val)
    },
    handleChange(item) {
      const { value, val, options } = this
      if (value == item.name) return
      
      const currentItem = options.find(i => i.name === value)
      let tips = []
      if (currentItem.color != item.color) {
        tips.push(`油墨颜色由【${currentItem.color}】调整为【${item.color}】`)
      }
      if (currentItem.bheight != item.bheight) { 
        tips.push(`板厚由【${currentItem.bheight}mm】调整为【${item.bheight}mm】`)
      }
      if (tips.length > 0) {
        this.$confirm(`您修改交期为 ${item.name}，我们需将${tips.join('，')}，请确认是否修改？`, '温馨提示', {
          confirmButtonText: '确定修改',
          cancelButtonText: '取消修改',
          lockScroll: false,
          center: true,
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          closeOnPressEscape: true
        })
        .then(() => {
          this.val = item.name
          this.handleEmit()
        })
        .catch(() => {
          this.val = value
          this.handleEmit()
        })
      } else {
        this.val = item.name
        this.handleEmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.deltime {
  .deltime__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 7px;
    .deltime__header__title {
      font-size: 13px;
      font-weight: 700;
      color: $--color-text-important;
    }
  }

  .deltime__colorHeader {
    display: flex;
    align-items: center;
    >span {
      margin-right: 4px;
    }
  }

  .deltime__color {
    display: flex;
    align-items: center;
  }
}
</style>